import { textColor } from "./colors.js";
const defaultLabelStyles = {
  fontFamily: '-apple-system,BlinkMacSystemFont,Roboto,Helvetica Neue,sans-serif',
  fontWeight: 700,
  fontSize: 12,
  textAnchor: 'middle',
  pointerEvents: 'none',
  letterSpacing: 0.4
};

/** Provides a simplified API to build a full XYChartTheme. */
export default function buildChartTheme(config) {
  const baseSvgLabel = {
    ...defaultLabelStyles,
    fill: textColor,
    stroke: 'none',
    ...config.svgLabelBig
  };
  const baseTickLabel = {
    ...defaultLabelStyles,
    fontWeight: 200,
    fontSize: 11,
    fill: textColor,
    stroke: 'none',
    ...config.svgLabelSmall
  };
  const baseHtmlLabel = {
    color: config.htmlLabel?.color ?? config.svgLabelBig?.fill ?? config.svgLabelSmall?.fill ?? textColor,
    ...defaultLabelStyles,
    ...config.htmlLabel
  };
  return {
    backgroundColor: config.backgroundColor,
    colors: [...config.colors],
    htmlLabel: {
      ...baseHtmlLabel
    },
    svgLabelSmall: {
      ...baseTickLabel
    },
    svgLabelBig: {
      ...baseSvgLabel
    },
    gridStyles: {
      stroke: config.gridColor,
      strokeWidth: 1,
      ...config.gridStyles
    },
    axisStyles: {
      x: {
        top: {
          axisLabel: {
            ...baseSvgLabel,
            dy: '-0.25em' // needs to include font-size
          },
          axisLine: {
            stroke: config.gridColorDark,
            strokeWidth: 2,
            ...config.xAxisLineStyles
          },
          tickLabel: {
            ...baseTickLabel,
            dy: '-0.25em' // needs to include font-size
          },
          tickLength: config.tickLength,
          tickLine: {
            strokeWidth: 1,
            stroke: config.gridColor,
            ...config.xTickLineStyles
          }
        },
        bottom: {
          axisLabel: {
            ...baseSvgLabel,
            dy: '-0.25em'
          },
          axisLine: {
            stroke: config.gridColorDark,
            strokeWidth: 2,
            ...config.xAxisLineStyles
          },
          tickLabel: {
            ...baseTickLabel,
            dy: '0.125em'
          },
          tickLength: config.tickLength,
          tickLine: {
            strokeWidth: 1,
            stroke: config.gridColor,
            ...config.xTickLineStyles
          }
        }
      },
      y: {
        left: {
          axisLabel: {
            ...baseSvgLabel,
            dx: '-1.25em'
          },
          axisLine: {
            stroke: config.gridColor,
            strokeWidth: 1,
            ...config.yAxisLineStyles
          },
          tickLabel: {
            ...baseTickLabel,
            textAnchor: 'end',
            dx: '-0.25em',
            dy: '0.25em'
          },
          tickLength: config.tickLength,
          tickLine: {
            strokeWidth: 1,
            stroke: config.gridColor,
            ...config.yTickLineStyles
          }
        },
        right: {
          axisLabel: {
            ...baseSvgLabel,
            dx: '1.25em'
          },
          axisLine: {
            stroke: config.gridColor,
            strokeWidth: 1,
            ...config.yAxisLineStyles
          },
          tickLabel: {
            ...baseTickLabel,
            textAnchor: 'start',
            dx: '0.25em',
            dy: '0.25em'
          },
          tickLength: config.tickLength,
          tickLine: {
            strokeWidth: 1,
            stroke: config.gridColor,
            ...config.yTickLineStyles
          }
        }
      }
    }
  };
}